/* @ngInject */
const trim = (valueHandler) => {
  return (value) => {
    if (!valueHandler.isString(value)) {
      return value
    }
    return value.replace(/^\s+|\s+$/g, '')
  }
}

export default trim



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/utils/trim.filter.js